import { useCallback, useEffect, useState } from 'react';
import api from '../utils/api.util';
import toast from '../utils/toast.util';
import { useAuth } from '../auth/AuthContext';
import { ENDPOINT } from '../constants/common-app.const';

const useGetThemeContent = ({
  contractId,
  themeId,
}: {
  contractId: string;
  themeId: string;
}) => {
  const [body, setBody] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const { isAuthenticated } = useAuth();

  const fetchContent = useCallback(async () => {
    try {
      setLoading(true);
      const response = await api.getJson(
        `${ENDPOINT.CONTRACTS}/${contractId}/themes/${themeId}/content`
      );
      setBody(response?.body ?? null);
      setLoading(false);
    } catch (err) {
      toast.showOnFailure('Ошибка загрузки содержимого темы');
      setError('fetch failed');
      setLoading(false);
    }
  }, [contractId, themeId]);

  useEffect(() => {
    if (isAuthenticated && contractId && themeId) {
      fetchContent();
    }
  }, [isAuthenticated, contractId, themeId, fetchContent]);

  return { body, loading, error };
};

export default useGetThemeContent;
